import axios from "axios";

import type {
    AdvanceProvisionList,
    AdvanceProvisionListParams,
    AdvanceProvisionRepository,
    AdvanceProvisionRule,
    AdvanceProvisionRulesResponse,
    AdvanceProvisionRuleType,
} from ".";

// REACT_APP_API_ENDPOINT already includes `/v1`.
const baseUrl = () => import.meta.env.REACT_APP_API_ENDPOINT + "/advance-provision";

export class AdvanceProvisionApi implements AdvanceProvisionRepository {
    async fetchRules(): Promise<AdvanceProvisionRulesResponse> {
        const response = await axios.get(`${baseUrl()}/rules`);
        return response.data.data;
    }

    async saveRules(
        ruleType: AdvanceProvisionRuleType,
        rules: AdvanceProvisionRule[],
    ): Promise<AdvanceProvisionRule[]> {
        const response = await axios.put(`${baseUrl()}/rules/${ruleType}`, { rules });
        return response.data.data;
    }

    async fetchList(params: AdvanceProvisionListParams): Promise<AdvanceProvisionList> {
        const response = await axios.get(baseUrl(), { params, timeout: 60_000 });
        return response.data.data;
    }

    async exportList(closingDate: string): Promise<{ url: string }> {
        const response = await axios.get(`${baseUrl()}/export`, { params: { closingDate }, timeout: 120_000 });
        return response.data;
    }
}
